module.exports = __webpack_public_path__ + "assets/img/菜单.10f99f03.png";